import { render, staticRenderFns } from "./UatAdminBlockedScreen.vue?vue&type=template&id=687aa5aa&scoped=true"
import script from "./UatAdminBlockedScreen.vue?vue&type=script&lang=js"
export * from "./UatAdminBlockedScreen.vue?vue&type=script&lang=js"
import style0 from "./UatAdminBlockedScreen.vue?vue&type=style&index=0&id=687aa5aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687aa5aa",
  null
  
)

export default component.exports